import { useSalaryReport } from './useSalaryReport';

export { useSalaryReport };
